import React from 'react';
import { Grid, TextField, Typography, MenuItem, Divider, Paper, FormControlLabel, Checkbox } from '@material-ui/core';
import TablaSesiones from "../../components/TablaSesiones";
import { FORM_DICTIONARY } from '../schemas/formFields';

/* =============================================
    PASO 1: Motivo y Antecedentes (Salud Mental)
   ============================================= */
function PasoSaludYRiesgo({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => data?.[field]?.error || '';
    const campos_generales = FORM_DICTIONARY.fichas.general;

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.nombre_eps.label}
                    name={campos_generales.nombre_eps.name}
                    value={safeValue(campos_generales.nombre_eps.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.nombre_eps.name)}
                    helperText={safeError(campos_generales.nombre_eps.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.sisben.label}
                    name={campos_generales.sisben.name}
                    value={safeValue(campos_generales.sisben.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.sisben.name)}
                    helperText={safeError(campos_generales.sisben.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.no_vinculado.label}
                    name={campos_generales.no_vinculado.name}
                    value={safeValue(campos_generales.no_vinculado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.no_vinculado.name)}
                    helperText={safeError(campos_generales.no_vinculado.name)}
                />
            </Grid>


            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.grupo_priorizado.label}
                    name={campos_generales.grupo_priorizado.name}
                    value={safeValue(campos_generales.grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.grupo_priorizado.name)}
                    helperText={safeError(campos_generales.grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.se_auto_reconoce_grupo_priorizado.label}
                    name={campos_generales.se_auto_reconoce_grupo_priorizado.name}
                    value={safeValue(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.certificado_grupo_priorizado.label}
                    name={campos_generales.certificado_grupo_priorizado.name}
                    value={safeValue(campos_generales.certificado_grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.certificado_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.certificado_grupo_priorizado.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            {[
                { label: campos_generales.ideacion_suicida.label, name: campos_generales.ideacion_suicida.name, required: true },
                { label: campos_generales.intento_suicida.label, name: campos_generales.intento_suicida.name, required: true },
                { label: campos_generales.conducta_suicida.label, name: campos_generales.conducta_suicida.name, required: true },
                { label: campos_generales.deseo_muerte.label, name: campos_generales.deseo_muerte.name, required: true },
                { label: campos_generales.deseo_danarse.label, name: campos_generales.deseo_danarse.name, required: true },
                { label: campos_generales.plan_suicida.label, name: campos_generales.plan_suicida.name, required: true },
                { label: campos_generales.trataste_suicidarte.label, name: campos_generales.trataste_suicidarte.name, required: true }
            ].map((preg) => (
                <Grid item xs={12} md={4} key={preg.name}>
                    <TextField 
                        fullWidth 
                        select 
                        label={preg.label} 
                        name={preg.name} 
                        value={safeValue(preg.name)} 
                        onChange={onChange}
                        required={preg.required}
                        error={!!safeError(preg.name)}
                        helperText={safeError(preg.name)}
                    >
                        <MenuItem value="SI">Sí</MenuItem>
                        <MenuItem value="NO">No</MenuItem>
                    </TextField>
                </Grid>
            ))}

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.toma_medicamentos.label}
                    name={campos_generales.toma_medicamentos.name}
                    value={safeValue(campos_generales.toma_medicamentos.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.toma_medicamentos.name)}
                    helperText={safeError(campos_generales.toma_medicamentos.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            {/* 👇 SOLO aparece si responde SI */}
            {safeValue(campos_generales.toma_medicamentos.name) === 'SI' && (
            <Grid item xs={12} md={4}>
                <TextField
                fullWidth
                label={campos_generales.nombre_medicamentos.label}
                name={campos_generales.nombre_medicamentos.name}
                value={safeValue(campos_generales.nombre_medicamentos.name)}
                onChange={onChange}
                required
                error={!!safeError(campos_generales.nombre_medicamentos.name)}
                helperText={safeError(campos_generales.nombre_medicamentos.name)}
                />
            </Grid>
            )}

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.diagnostico_previo.label}
                    name={campos_generales.diagnostico_previo.name}
                    value={safeValue(campos_generales.diagnostico_previo.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.diagnostico_previo.name)}
                    helperText={safeError(campos_generales.diagnostico_previo.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            {/* 👇 SOLO aparece si responde SI */}
            {safeValue(campos_generales.diagnostico_previo.name) === 'SI' && (
            <Grid item xs={12} md={4}>
                <TextField
                fullWidth
                label={campos_generales.diagnostico.label}
                name={campos_generales.diagnostico.name}
                value={safeValue(campos_generales.diagnostico.name)}
                onChange={onChange}
                required
                error={!!safeError(campos_generales.diagnostico.name)}
                helperText={safeError(campos_generales.diagnostico.name)}
                />
            </Grid>
            )}

            <Grid item xs={12} md={12}></Grid>

        </Grid>
    );
}

/* =============================================
    PASO 2: Motivo de Consulta e Historia Psicosocial
   ============================================= */
function PasoHistoriaPsicosocial({data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => data?.[field]?.error || '';
    const campos = FORM_DICTIONARY.fichas.psicologia;

        const CAMPOS_DESCRIPCION = [
            { label: campos.descripcion_motivo_consulta.label, name: campos.descripcion_motivo_consulta.name, required: true },
            { label: campos.motivo_consulta.label, name: campos.motivo_consulta.name, required: true },
            { label: campos.informacion_personal_familiar.label, name: campos.informacion_personal_familiar.name, required: true },
            { label: campos.informacion_academica.label, name: campos.informacion_academica.name, required: true },
            { label: campos.aspectos_relevantes.label, name: campos.aspectos_relevantes.name, required: true }
            ];

    return (
        <Grid container spacing={2}>

            {CAMPOS_DESCRIPCION.map(campo => (
                <Grid item xs={12} key={campo.name}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label={campo.label}
                    name={campo.name}
                    value={safeValue(campo.name)}
                    onChange={onChange}
                    required={campo.required}
                    error={!!safeError(campo.name)}
                    helperText={safeError(campo.name)}
                />
                </Grid>
            ))}

        </Grid>
    );
}



/* =============================================
    PASO 3: Plan de Intervención y Sesiones
   ============================================= */


function PasoPlanPsicologico({ data, onChangeSesion }) {

  const handleSesionesChange = (nuevasSesiones) => {
    onChangeSesion(nuevasSesiones);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TablaSesiones
          sesiones={data.sesiones}
          onChange={handleSesionesChange}
        />
      </Grid>
    </Grid>
  );
}


/* =============================================
    EXPORTACIÓN DE PASOS
   ============================================= */
export const StepsAsesoriaPsicologica = [
    { label: 'Salud y Riesgo', render: (props) => <PasoSaludYRiesgo {...props} /> },
    { label: 'Descripción', render: (props) => <PasoHistoriaPsicosocial {...props} /> },
    { label: 'Plan de Manejo', render: (props) => <PasoPlanPsicologico {...props} /> }
];